<template>
  <div
    class="LineFloatBtn"
  >
    <v-layout
      align-center
      class="ma-0"
    >
      <div
        v-if="hovering"
        class="mr-3 white black--text py-2 px-3 text"
      >
        Line
      </div>
      <div
        v-else-if="!cliked"
        class="mr-3 white black--text py-2 px-3 text"
      >
        需要協助嗎？立即諮詢我們
      </div>
      <div
        :class="{unclicked: !cliked}"
        class="icon-wrap"
        @mouseover="hovering = true"
        @mouseleave="hovering = false"
        @click="handleClick()"
      >
        <a
          href="https://line.me/ti/p/@kkren"
          target="_blank"
        >
          <img
            src="/static/images/icon/line.png"
            width="54"
            height="54"
            style="vertical-align: middle;"
            class="icon"
          >
        </a>
        <span
          v-if="!cliked"
          class="peding-msg"
        >1</span>
      </div>
    </v-layout>
  </div>
</template>
<script>
export default {
  data () {
    return {
      hovering: false,
      cliked: localStorage.getItem('lineFloatBtnClicked') === '1',
    }
  },
  methods: {
    handleClick () {
      this.cliked = true
      localStorage.setItem('lineFloatBtnClicked', '1')
    }
  },
}
</script>
<style lang="postcss" scoped>
@keyframes chaty-animation-shockwave {
  0% {
    transform: scale(1);
    box-shadow: 0 0 2px rgba(0,0,0,.3),inset 0 0 1px rgba(0,0,0,.3)
  }

  95% {
    box-shadow: 0 0 50px transparent,inset 0 0 30px transparent
  }

  100% {
    transform: scale(2.25)
  }
}

.LineFloatBtn {
  position: fixed;
  right: 30px;
  bottom: 20px;
  z-index: 999;
  .text {
    box-shadow: 0 1.93465px 7.73859px rgb(0 0 0 / 15%);
    position: relative;
    border-radius: 10px;
    font-size: 16px;
    /* 右箭頭 */
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      right: -20px;
      width: 0;
      height: 0;
      border: 14px solid transparent;
      border-left-color: #fff;
      margin-top: -14px;
    }
  }
}
.icon-wrap {
  position: relative;
  &.unclicked:before,&.unclicked:after {
    content: "";
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    pointer-events: none;
  }
  &:after {
    animation: 2s ease-out 1.3s infinite chaty-animation-shockwave;
  }
  &:before {
    animation: 2s ease-out .8s infinite chaty-animation-shockwave;
  }
  .icon {
    border-radius: 50%;;
    box-shadow: 0 3px 6px rgb(0 0 0 / 25%);
  }
  .peding-msg {
    position: absolute;
    right: -4px;
    top: -4px;
    width: 16px;
    height: 16px;
    text-align: center;
    background: red;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
    border-radius: 50%;
    z-index: 1101;
  }
}
</style>
